module.exports = __webpack_public_path__ + "static/media/cross.59a9ef0c.svg";